// extracted by css-extract-rspack-plugin
export default {"info":"src-domain-components-avatar-with-name-list-col-AvatarWithNameListCol-module__info-o_RGUW"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"info\":\"src-domain-components-avatar-with-name-list-col-AvatarWithNameListCol-module__info-o_RGUW\"}";
        // 1793705033181
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  